module.exports = __webpack_public_path__ + "static/header-bg-6b5a574639cd9d6aefcfc5b287adfe50.jpg";